module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "terms"
  }, [_c('navbar', {
    attrs: {
      "transparent": _vm.isTransparent,
      "activeTo": "Home"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "terms_page max_width"
  }, [_c('div', {
    staticClass: "terms_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('privacy_policy'))
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "terms_content",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('privacy_policy_content'))
    }
  }), _vm._v(" "), _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      staticClass: "terms_main"
    }, [_c('h1', {
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    }, [_vm._v(_vm._s(item.content))])])
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36317e92","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/privacy_policy.vue
// module id = 801
// module chunks = 0